export var getConfigVentanas = function getConfigVentanas(state, ventana_id) {
  return state.configVentanas[ventana_id] || {
    flotante: false,
    escalable: false
  };
};